import { formatKoreanNumber } from '@domains/pdp-common';

export const getMinimumOrderText = (min_amount: number) => {
  return min_amount > 0 ? `(${formatKoreanNumber(min_amount)} 이상)` : '';
};
